import React from 'react'

type Props = {
  bodyScroll: boolean
  children: React.ReactNode
  innerRef?: React.RefObject<HTMLDivElement>
}

function ScrollableList({ bodyScroll, children, innerRef }: Props) {
  const outerRef = React.useRef<HTMLDivElement>(null)
  const defaultInnerRef = React.useRef<HTMLDivElement>(null)

  const scrollToBottom = () => {
    if (bodyScroll) {
      window.scrollTo({ top: outerRef.current!.scrollHeight, behavior: 'auto' })
    } else {
      outerRef.current!.scrollTo({ top: outerRef.current!.scrollHeight, behavior: 'auto' })
    }
  }

  React.useEffect(() => {
    const currentRef = innerRef?.current || defaultInnerRef.current
    if (!currentRef) return
    const resizeObserver = new ResizeObserver(() => scrollToBottom())
    resizeObserver.observe(currentRef)
    return () => resizeObserver.disconnect()
  }, [])

  return (
    <div className='pilot-completions-list' ref={outerRef}>
      <div className='pilot-completions-list__inner_scroll' ref={innerRef || defaultInnerRef}>
        {children}
      </div>
    </div>
  )
}

export default ScrollableList
